import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';

function Reviewers({title}) {

    useEffect(() => {
        document.title = title;
    }, [title]);

    const [reviewers, setReviewers] = useState([]);

    useEffect(() => {
            fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllReviewers')
              .then(res => res.json())
              .then(data => {
                if (data.success) {
                    setReviewers(data.reviewers);
                }
              })
              .catch(err => console.error('Failed to fetch issues:', err));
    }, []);

    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper">
                <h2 className='instructions_title'>
                   Reviewers
                </h2>

                <hr class="instructions_hr"/>
                
                <ul className='reviewers_ul'>              
                    {reviewers.slice().reverse().map((reviewer) => (
                        <li key={reviewer.id} className='instructions_p reviewers_p'>
                            {parse(reviewer.title)}
                        </li>
                    ))}
                </ul>


                
            </div>
        </div>
      </>
    );
}

export default Reviewers;